import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityActividadesState } from './entity-actividades.state';
import { entityActividadesAdapter } from './entity-actividades.state';
import {
  entityActividadesLoadRequest,
  entityActividadesLoadSuccess,
  entityActividadesLoadFailure,
  entityActividadesAddFailure,
  entityActividadesAddRequest,
  entityActividadesAddSuccess,
  entityActividadesChangeFailure,
  entityActividadesChangeRequest,
  entityActividadesChangeSuccess,
  entityActividadesDeleteFailure,
  entityActividadesDeleteRequest,
  entityActividadesDeleteSuccess
} from './entity-actividades.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityActividadesLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesLoadSuccess, (state, { items }) =>
    entityActividadesAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityActividadesAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesAddSuccess, (state, { item }) => {
    return entityActividadesAdapter.addMany(item.actividades, {
      ...state,
      isLoading: false,
      error: null
    })
  }),
  // change
  on(entityActividadesChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesChangeSuccess, (state, { item }) =>
    entityActividadesAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityActividadesDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityActividadesDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityActividadesDeleteSuccess, (state, { item }) =>
    entityActividadesAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function actividadesReducer(
  state: EntityActividadesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
